export default __webpack_public_path__ + "static/media/travel.522e2c7c.png";